/**
 * «Сообщить об ошибке» (владелец, 23.10.2026: «во все рецепты и вообще на страницы, что можно было написать,
 * если найдена ошибка, и за это нужно начислять баллы как за правку субтитров»). Контракт с site_server —
 * POST /api/error-reports и админские GET/POST /api/admin/error-reports (api/errorReportApi.ts).
 */

/** О чём сообщение: страница сайта, рецепт, продукт, блюдо «Что в блюде». */
export type ErrorReportKind = "page" | "recipe" | "product" | "dish_photo";

export const ERROR_REPORT_KINDS: readonly ErrorReportKind[] = ["page", "recipe", "product", "dish_photo"];

/** Где в рецепте ошибка (контракт: context.part). */
export type ErrorReportPart = "name" | "ingredient" | "step" | "nutrition" | "other";

export const ERROR_REPORT_PARTS: readonly ErrorReportPart[] = ["name", "ingredient", "step", "nutrition", "other"];

/** Языки сайта (первый сегмент адреса). */
export type ErrorReportLang = "ru" | "en" | "de" | "es" | "cn" | "ar";

export const ERROR_REPORT_LANGS: readonly ErrorReportLang[] = ["ru", "en", "de", "es", "cn", "ar"];

/**
 * Рецепт: ошибка может быть и в переводе, поэтому сообщение несёт русский оригинал (quoteRu — шаг или
 * название, как в каталоге) и язык страницы (его берёт лист).
 */
export interface RecipeReportContext {
    /** id блюда каталога («web-001», «ak-00006»). */
    dishId: string;
    /** Название блюда по-русски (как в каталоге). */
    dishName: string;
    /** Версия каталога (RECIPES_VERSION / NAMES_CATALOGUE_VERSION). */
    catalogueVersion?: string;
    /** Адрес рецепта-источника (у настоящих рецептов — сайт рецептов). */
    sourceUrl?: string;
    part?: ErrorReportPart;
    /** Номер шага с нуля (part "step"). */
    stepIndex?: number;
    /** Русский оригинал того, о чём сообщение: шаг, название. */
    quoteRu?: string;
}

/** Продукт: id и название каталога. */
export interface ProductReportContext {
    productId: number | string;
    productName: string;
}

/** Что открывает лист: страница, кнопка острова рецептов, «Что в блюде». */
export interface ErrorReportRequest {
    /** По умолчанию — страница. */
    kind?: ErrorReportKind;
    /** Выделенный текст. Не задан — лист возьмёт текущее выделение страницы. */
    selectedText?: string;
    /** Что написать в строке «Где»: название рецепта, продукта, блюда. */
    title?: string;
    /** Подробности для администратора (контракт: context, не больше 4 КБ в JSON). */
    context?: Record<string, unknown>;
}
